<template>
    <div id="app">
        <div id="job_search">
            <input :placeholder="$t('job_search')" v-model="searchString" type="text">
            <svg width="24" height="24" style="position: absolute;top: 21px;left: 60px;" version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1244.000000 1280.000000" preserveAspectRatio="xMidYMid meet">
                <g transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)" fill="#9D9D9D" stroke="none">
                    <path d="M4030 12780 c-330 -30 -522 -62 -785 -130 -619 -160 -1185 -453 -1700 -881 -129 -107 -407 -385 -514 -514 -567 -683 -904 -1468 -995 -2325 -37 -340 -41 -461 -22 -690 10 -118 24 -264 32 -325 105 -818 442 -1583 978 -2225 103 -124 344 -367 476 -482 590 -513 1294 -852 2063 -993 410 -75 943 -86 1362 -29 633 87 1285 335 1801 684 40 26 82 54 94 60 21 11 157 -122 2449 -2413 1931 -1930 2436 -2430 2476 -2450 78 -38 192 -69 239 -64 119 13 220 59 304 141 84 81 136 190 149 312 5 46 -25 161 -64 239 -20 40 -515 540 -2429 2455 -1322 1323 -2404 2408 -2404 2412 0 4 31 42 68 86 1076 1249 1350 3000 705 4511 -105 245 -218 454 -379 696 -491 740 -1196 1311 -2019 1634 -426 168 -769 245 -1290 291 -261 23 -337 23 -595 0z m735 -924 c652 -92 1208 -330 1715 -735 118 -95 337 -307 440 -426 757 -882 1013 -2057 694 -3175 -113 -395 -335 -829 -588 -1150 -697 -884 -1751 -1366 -2865 -1309 -1176 60 -2224 712 -2810 1746 -192 339 -337 766 -395 1163 -52 356 -45 765 19 1115 241 1311 1241 2374 2535 2695 175 44 348 72 575 94 94 9 575 -4 680 -18z"/> 
                </g>
            </svg>
        </div>
        <div id="job_sidebar">
            <div class="filter__header">
                <h3 @click="toggleMobileFilter()">{{$t("filter")}}</h3>
                <button @click="clearFilter()" class="link">{{$t("delete")}}</button>
            </div>
            <hr class="line">
            <div class="filter__category--wrapper">
                <div class="filter__category" :class="{'visible': mobileCategoryVisible}">
                    <h3 @click="toggleCategoryVisible()" class="category__headline">{{$t("category")}}</h3>
                    <div class="filter__wrapper">
                        <div v-bind:class="['filter', {active: category.selected}]" v-for="category in job_categories" :key="category.id" @click="toggleSelected('job_categories', category.id)">
                            <div v-if="category.selected" class="fake--input"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" data-v-7c5af296=""><path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" fill="#FFFFFF" data-v-7c5af296=""></path></svg></div>
                            <input v-else type="checkbox" :name="category.id" :id="category.id">
                            <label>{{category.text}}</label>
                        </div>
                    </div>
                </div>
                <div class="filter__category" :class="{'visible': mobileLocationVisible}">
                    <h3 @click="toggleLocationVisible()" class="category__headline">{{$t("location")}}</h3>
                    <div class="filter__wrapper">
                        <div v-bind:class="['filter', {active: location.selected}, {'filter--hidden': !location.visible}]" v-for="location in job_locations" :key="location.id">
                            <div v-if="location.visible" class="filter--main" @click="toggleSelected('job_locations', location.id, 'main')">
                                <div v-if="location.selected" class="fake--input"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" data-v-7c5af296=""><path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" fill="#FFFFFF" data-v-7c5af296=""></path></svg></div>
                                <input v-else type="checkbox" :name="location.id" :id="location.id">
                                <label>{{location.text}}</label>
                            </div>
                            <template v-for="subsidiary in location.entries">
                                <div v-if="subsidiary.visible" class="filter--sub"  @click="toggleSelected('job_locations', subsidiary.id, 'sub')" :key="subsidiary.id">
                                    <div v-if="subsidiary.selected" class="fake--input"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" data-v-7c5af296=""><path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" fill="#FFFFFF" data-v-7c5af296=""></path></svg></div>
                                    <input v-else type="checkbox" :name="subsidiary.id" :id="subsidiary.id">
                                    <label>{{subsidiary.text}}</label>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="filter__category" :class="{'visible': mobileTypeVisible}">
                    <h3 @click="toggleTypeVisible()" class="category__headline">{{$t("type")}}</h3>
                    <div class="filter__wrapper">
                        <template v-for="type in job_types">
                            <div :key="type.id" v-if="type.id !== 'student'" v-bind:class="['filter', {active: type.selected}]"  @click="toggleSelected('job_types', type.id)">
                                <div v-if="type.selected" class="fake--input"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" data-v-7c5af296=""><path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" fill="#FFFFFF" data-v-7c5af296=""></path></svg></div>
                                <input v-else type="checkbox" :name="type.id" :id="type.id">
                                <label>{{type.text}}</label>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <main id="job_content">
            <h2 v-if="entryCount() > 0">{{$t("find_your_job")}} ({{entryCount()}})</h2>
            <div class="job__wrapper" v-if="jobs || default_jobs">
                <job-list v-if="jobs" :jobs="jobs" :page="currentPage-1" :perPage="perPage"></job-list>

                <div v-if="jobs.length > 0" class="job__pagination">
                    <div v-if="currentPage != 1" @click="pagination('subtract')" class="pagination__entry first">
                        <div class="arrow">&nbsp;</div>
                    </div>
                    <template v-for="index in Math.ceil(this.jobs.length / this.perPage)">
                        <div @click="pagination(index)" :class="['pagination__entry', {active: (currentPage == index)}]" v-if="currentPage == index || currentPage - 1 == index || currentPage + 1 == index"  :key="index">{{index}}</div>
                    </template>
                    <div v-if="(currentPage) != Math.ceil(jobs.length / perPage)" @click="pagination('add')" class="pagination__entry last">
                        <div class="arrow">&nbsp;</div>
                    </div>
                </div>
                <div v-if="jobs.length == 0">
                    <job-list :jobs="initiativ_jobs" :page="currentPage-1" :perPage="perPage"></job-list>
                </div>
            </div>
            <div v-else class="placeholder"></div>
        </main>
    </div>
</template>

<script>
import JobList from '@/components/JobList.vue';
import axios from 'axios';
export default {
    name: 'App',
	components: {
        JobList
    },
    data() {
        return {
            job_categories: {
                "sales_customer_support": {
                    'id':       'sales_customer_support',
                    'text':     'Sales & Customer Support',
                    'selected': false,
                },
                "product_technology": {
                    'id':       'product_technology',
                    'text':     'Product & Technology',
                    'selected': false,
                },
                "marketing_design": {
                    'id':       'marketing_design',
                    'text':     'Marketing & Design',
                    'selected': false,
                },
                "supply_chain_management_logistics": {
                    'id':       'supply_chain_management_logistics',
                    'text':     'Supply Chain & Logistics',
                    'selected': false,
                },
                "operations": {
                    'id':       'operations',
                    'text':     'Operations',
                    'selected': false,
                },
                "campus": {
                    'id':       'campus',
                    'text':     'Hotel & Gastronomy',
                    'selected': false,
                }
            },
            job_types: {
                "full_time": {
                    'id':       'full_time',
                    'text':     this.$t('types.full_time'),
                    'selected': false,
                },
                "part_time": {
                    'id':       'part_time',
                    'text':     this.$t('types.part_time'),
                    'selected': false,
                },
                "apprenticeship": {
                    'id':       'apprenticeship',
                    'text':     this.$t('types.apprenticeship'),
                    'selected': false,
                },
                "internship": {
                    'id':       'internship',
                    'text':     this.$t('types.internship'),
                    'selected': false,
                },
                "student": {
                    'id':       'student',
                    'text':     'Student',
                    'selected': false,
                },
            },
            job_locations: {
                'at': {
                    'id':       'at',
                    'text':     this.$t('locations.at.title'),
                    'selected': false,
                    'visible': false,
                    'entries' : {
                        'at-ko': {
                            'id':       'at-ko',
                            'text':     this.$t('locations.at.ko'),
                            'selected': false,
                            'visible': false,
                        },
                        'at-al': {
                            'id':       'at-al',
                            'text':     this.$t('locations.at.al'),
                            'selected': false,
                            'visible': false,
                        },
                        'at-wi': {
                            'id':       'at-wi',
                            'text':     this.$t('locations.at.wi'),
                            'selected': false,
                            'visible': false,
                        },
                    }
                },
                'de': {
                    'id':       'de',
                    'text':     this.$t('locations.de.title'),
                    'selected': false,
                        'visible': false,
                    'entries' : {
                        'de-wa': {
                            'id':       'de-wa',
                            'text':     this.$t('locations.de.wa'),
                            'selected': false,
                            'visible': false,
                        },
                        'de-du': {
                            'id':       'de-du',
                            'text':     'Düsseldorf',
                            'selected': false,
                            'visible': false,
                        },
                        'de-ha': {
                            'id':       'de-ha',
                            'text':     this.$t('locations.de.ha'),
                            'selected': false,
                            'visible': false,
                        },
                    }
                },
                'ch': {
                    'id':       'ch',
                    'text':     this.$t('locations.ch.title'),
                    'selected': false,
                    'visible': false,
                    'entries' : {
                        'ch-st': {
                            'id':       'ch-st',
                            'text':     this.$t('locations.ch.st'),
                            'selected': false,
                            'visible': false,
                        },
                        'ch-be': {
                            'id':       'ch-be',
                            'text':     this.$t('locations.ch.be'),
                            'selected': false,
                            'visible': false,
                        },
                    }
                },
                'it': {
                    'id':       'it',
                    'text':     this.$t('locations.it.title'),
                    'selected': false,
                    'visible': false,
                    'entries' : {
                        'it-ne': {
                            'id':       'it-ne',
                            'text':     this.$t('locations.it.ne'),
                            'selected': false,
                            'visible': false,
                        },
                        'it-mi': {
                            'id':       'it-mi',
                            'text':     this.$t('locations.it.mi'),
                            'selected': false,
                            'visible': false,
                        },
                        'it-su': {
                            'id':       'it-su',
                            'text':     this.$t('locations.it.su'),
                            'selected': false,
                            'visible': false,
                        },
                    }
                },
                'es': {
                    'id':       'es',
                    'text':     this.$t('locations.es.title'),
                    'selected': false,
                    'visible': false,
                    'entries' : {
                        'es-ar': {
                            'id':       'es-ar',
                            'text':     this.$t('locations.es.ar'),
                            'selected': false,
                            'visible': false,
                        },
                        'es-ma': {
                            'id':       'es-ma',
                            'text':     this.$t('locations.es.ma'),
                            'selected': false,
                            'visible': false,
                        },
                    }
                },
                'fr': {
                    'id':       'fr',
                    'text':     this.$t('locations.fr.title'),
                    'selected': false,
                    'visible': false,
                },
                'cz': {
                    'id':       'cz',
                    'text':     this.$t('locations.cz.title'),
                    'selected': false,
                    'visible': false,
                },
                'sk': {
                    'id':       'sk',
                    'text':     this.$t('locations.sk.title'),
                    'selected': false,
                    'visible': false,
                },
                'pl': {
                    'id':       'pl',
                    'text':     this.$t('locations.pl.title'),
                    'selected': false,
                    'visible': false,
                },
                'be': {
                    'id':       'be',
                    'text':     this.$t('locations.be.title'),
                    'selected': false,
                    'visible': false,
                },
                'nl': {
                    'id':       'nl',
                    'text':     this.$t('locations.nl.title'),
                    'selected': false,
                    'visible': true,
                },
                'uk': {
                    'id':       'uk',
                    'text':     this.$t('locations.uk.title'),
                    'selected': false,
                    'visible': false,
                },
                'cn': {
                    'id':       'cn',
                    'text':     this.$t('locations.cn.title'),
                    'selected': false,
                    'visible': false,
                },
                'us': {
                    'id':       'us',
                    'text':     this.$t('locations.us.title'),
                    'selected': false,
                    'visible': false,
                },
            },
            jobs: null,
            default_jobs: null,
            initiativ_jobs: null,
            currentPage: 1,
            perPage: 10,
            searchString: '',
            filterVisible: true,
            mobileCategoryVisible: false,
            mobileLocationVisible: false,
            mobileTypeVisible: false,
        }
    },
    methods: {
        pagination(meta) {

            window.scrollTo(0, 0);
            if(meta == "add") {
                this.currentPage = this.currentPage + 1;
            } else if(meta == "subtract") {
                this.currentPage = this.currentPage - 1;
            } else {
                this.currentPage = meta;
            }
        },
        toggleSelected(object, id, type="") {
            if(object == "job_types") {
                    for (const [filter_key, filter_value] of Object.entries(this.job_types)) {
                        if(filter_key == id){
                            filter_value.selected = !filter_value.selected;
                        }
                    }
            }
            if(object == "job_categories") {
                    for (const [filter_key, filter_value] of Object.entries(this.job_categories)) {
                        if(filter_key == id){
                            filter_value.selected = !filter_value.selected;
                        }
                    }
            }
            if(object == "job_locations") {
                if(type == "main") {
                    for (const [filter_key, filter_value] of Object.entries(this.job_locations)) {
                        if(filter_key == id){
                            filter_value.selected = !filter_value.selected;
                            if(filter_value.entries){
                                for(const [key, value] of Object.entries(filter_value.entries)) {
                                    if(key){
                                        value.selected = filter_value.selected;
                                    }
                                }
                            }
                        }
                    }
                }else if(type == "sub") {
                    for (const [filter_key, filter_value] of Object.entries(this.job_locations)) {

                        if(filter_value.entries && filter_key){
                            for(const [key, value] of Object.entries(filter_value.entries)) {
                                if(key == id){
                                    value.selected = !value.selected;
                                }
                            }
                        }
                    }
                }
            }
            this.handleUrl();
            this.updateJobList();
        },
        handleUrl() {
            localStorage.setItem('selected_categories', null);
            localStorage.setItem('selected_locations', null);
            localStorage.setItem('selected_types', null);


            
            var selected_types = [];
            var selected_categories = [];
            var selected_locations = [];

            for (const [filter_key, filter_value] of Object.entries(this.job_types)) {
                if(filter_value.selected){
                    selected_types.push(filter_key);
                }
            }

            for (const [filter_key, filter_value] of Object.entries(this.job_categories)) {
                if(filter_value.selected){
                    selected_categories.push(filter_key);
                }
            }

            for (const [filter_key, filter_value] of Object.entries(this.job_locations)) {
                if(filter_value.selected){
                    selected_locations.push(filter_key);
                }
                if(filter_value.entries && filter_key){
                    for(const [key, value] of Object.entries(filter_value.entries)) {
                        if(value.selected){
                            selected_locations.push(key);
                        }
                    }
                }
            }

            localStorage.setItem('selected_categories', selected_categories);
            localStorage.setItem('selected_locations', selected_locations);
            localStorage.setItem('selected_types', selected_types);
        },
        clearFilter() {
            for (const [filter_key, filter_value] of Object.entries(this.job_types)) {
                if(filter_key != "false") {
                    filter_value.selected = false;
                }
            }
            for (const [filter_key, filter_value] of Object.entries(this.job_categories)) {
                if(filter_key != "false") {
                    filter_value.selected = false;
                }
            }
            for (const [filter_key, filter_value] of Object.entries(this.job_locations)) {
                if(filter_key != "false") {
                    filter_value.selected = false;
                }

                if(filter_value.entries){
                    for (const [key, value] of Object.entries(filter_value.entries)) {
                        if(key != "false") {
                            value.selected = false;
                        }
                    }
                }
            }

            this.mobileLocationVisible = false;
            this.mobileTypeVisible = false;
            this.mobileCategoryVisible = false;
            this.searchString = "";
            this.updateJobList();
        },
        entryCount() {
            
            if(this.jobs) {
                return Object.keys(this.jobs).length;
            }
            return 0;
        },
        updateJobList() {
            this.currentPage = 1;
            this.jobs = [];

            this.default_jobs.forEach(job => {
                let filterPassed = true;
                // Filter Job Types 
                let wantedJobTypeKeywords = [];

                for(const [filter_key, filter_value] of Object.entries(this.job_types)) {
                    if(filter_value.selected) {

                        if(filter_key == "full_time") {
                            wantedJobTypeKeywords.push(...["Vollzeit", "full-time / part-time", "full-time", "Full time"]);
                        } else if(filter_key == "part_time") {
                            wantedJobTypeKeywords.push(...["Teilzeit ab 20 h/Woche", "Geringfügig", "Freelancer", "Projektarbeit", "full-time / part-time", "part-time", "Part time"]);
                        } else if(filter_key == "apprenticeship") {
                            wantedJobTypeKeywords.push(...["Ausbildung", "Apprenticeship"]);
                        } else if(filter_key == "internship") {
                            wantedJobTypeKeywords.push(...["Ferialjob", "Praktikum", "Berufspraktikum", "Diplomarbeit / Dissertation", "Internship"]);
                        } else if(filter_key == "student") {
                            wantedJobTypeKeywords.push(...["Student", "Internship"]);
                        }
                    }
                }

                if(wantedJobTypeKeywords.length > 0) {
                    for(const type of job.type.split(";")) {
                        if(!wantedJobTypeKeywords.includes(type)) {
                            filterPassed = false;
                        }else{
                            filterPassed = true;
                        }
                    }
                }
                
                // Filter Job Categories
                if (filterPassed === true) {
                    let wantedJobCategoryKeywords = [];

                    for(const [filter_key, filter_value] of Object.entries(this.job_categories)) {
                        if(filter_value.selected) {
                            if(filter_key == "product_technology") {
                                wantedJobCategoryKeywords.push(...["Product & Technology"]);
                            } else if(filter_key == "marketing_design") {
                                wantedJobCategoryKeywords.push(...["Marketing & Design"]);
                            } else if(filter_key == "sales_customer_support") {
                                wantedJobCategoryKeywords.push(...["Sales & Customer Support"]);
                            } else if(filter_key == "supply_chain_management_logistics") {
                                wantedJobCategoryKeywords.push(...["Supply Chain Management & Logistics"]);
                            } else if(filter_key == "operations") {
                                wantedJobCategoryKeywords.push(...["Operations"]);
                            } else if(filter_key == "campus") {
                                wantedJobCategoryKeywords.push(...["Campus"]);
                            }
                        }
                    }
 
                    if(wantedJobCategoryKeywords.length > 0) {
                        for(const category of job.job_categories.split(';')) {
                            if(!wantedJobCategoryKeywords.includes(category)) {
                                filterPassed = false;
                            }else{
                                filterPassed = true;
                            }
                        }
                    }





                    // Filter Job Locations
                    if (filterPassed === true) {
                        let wantedJobLocationKeywords = [];

                        for(const [filter_key, filter_value] of Object.entries(this.job_locations)) {
                            if(filter_value.selected) {
                                if(filter_key == "at") {
                                    //wantedJobLocationKeywords.push(...["AT - 4154 Kollerschlag", "AT - 4211 Alberndorf", "AT - 1010 Wien"]);
                                } else if(filter_key == "at-ko") {
                                    wantedJobLocationKeywords.push(...["AT - 4154 Kollerschlag"]);
                                } else if(filter_key == "at-al") {
                                    wantedJobLocationKeywords.push(...["AT - 4211 Alberndorf"]);
                                } else if(filter_key == "at-wi") {
                                    wantedJobLocationKeywords.push(...["AT - 1010 Wien"]);
                                }else if(filter_key == "de") {
                                    //wantedJobLocationKeywords.push(...["DE - 73116 Wäschenbeuren", "DE - 30916 Isernhagen, Altwarmbüchen", "DE - Düsseldorf und Umgebung"]);
                                }else if(filter_key == "de-wa") {
                                    wantedJobLocationKeywords.push(...["DE - 73116 Wäschenbeuren"]);
                                }else if(filter_key == "de-ha") {
                                    wantedJobLocationKeywords.push(...["DE - 30916 Isernhagen, Altwarmbüchen"]);
                                }else if(filter_key == "de-du") {
                                    wantedJobLocationKeywords.push(...["DE - Düsseldorf und Umgebung"]);
                                }else if(filter_key == "ch") {
                                    wantedJobLocationKeywords.push(...["CH - 8266 Steckborn"]);
                                }else if(filter_key == "ch-st") {
                                    wantedJobLocationKeywords.push(...["CH - 8266 Steckborn"]);
                                }else if(filter_key == "ch-be") {
                                    wantedJobLocationKeywords.push(...["CH - 8266 Steckborn"]);
                                }else if(filter_key == "it") {
                                    //wantedJobLocationKeywords.push(...["IT - 39044 Neumarkt", "IT - Milan"]);
                                }else if(filter_key == "it-ne") {
                                    wantedJobLocationKeywords.push(...["IT - 39044 Neumarkt"]);
                                }else if(filter_key == "it-mi") {
                                    wantedJobLocationKeywords.push(...["IT - Milan"]);
                                }else if(filter_key == "it-su") {
                                    wantedJobLocationKeywords.push(...["IT - Südtirol"]);
                                }else if(filter_key == "es") {
                                    wantedJobLocationKeywords.push(...["ES - 08271 Artés", "ES - 28046 Madrid"]);
                                }else if(filter_key == "es-ar") {
                                    wantedJobLocationKeywords.push(...["ES - 08271 Artés"]);
                                }else if(filter_key == "es-ma") {
                                    wantedJobLocationKeywords.push(...["ES - 28046 Madrid"]);
                                }else if(filter_key == "fr") {
                                    wantedJobLocationKeywords.push(...["FR - 69150 Décines-Charpieu", "FR - 69740 Genas"]);
                                }else if(filter_key == "cz") {
                                    wantedJobLocationKeywords.push(...["CZ - 370 11 České Budějovice", "CZ - Prague"]);
                                }else if(filter_key == "sk") {
                                    wantedJobLocationKeywords.push(...["SK - 07 Vajnory"]);
                                }else if(filter_key == "pl") {
                                    wantedJobLocationKeywords.push(...["PL - 41-902 Bytom", "PL - 02-674 Warszawa", "PL - Warszawa"]);
                                }else if(filter_key == "be") {
                                    wantedJobLocationKeywords.push(...["BEL - 2560 Nijlen"]);
                                }else if(filter_key == "nl") {
                                    wantedJobLocationKeywords.push(...["NL - Amsterdam"]);
                                }else if(filter_key == "uk") {
                                    wantedJobLocationKeywords.push(...["UK - Theale RG7 4RA"]);
                                }else if(filter_key == "cn") {
                                    wantedJobLocationKeywords.push(...["CN - Shanghai"]);
                                }else if(filter_key == "us") {
                                    wantedJobLocationKeywords.push(...["US - PA 19060"]);
                                }
                            }
                            if(filter_value.entries){
                                for(const [key, value] of Object.entries(filter_value.entries)) {
                                    if(value.selected) {
                                        if(key == "at") {
                                            //wantedJobLocationKeywords.push(...["AT - 4154 Kollerschlag", "AT - 4211 Alberndorf", "AT - 1010 Wien"]);
                                        } else if(key == "at-ko") {
                                            wantedJobLocationKeywords.push(...["AT - 4154 Kollerschlag"]);
                                        } else if(key == "at-al") {
                                            wantedJobLocationKeywords.push(...["AT - 4211 Alberndorf"]);
                                        } else if(key == "at-wi") {
                                            wantedJobLocationKeywords.push(...["AT - 1010 Wien"]);
                                        }else if(key == "de") {
                                            //wantedJobLocationKeywords.push(...["DE - 73116 Wäschenbeuren", "DE - 30916 Isernhagen, Altwarmbüchen", "DE - Düsseldorf und Umgebung"]);
                                        }else if(key == "de-wa") {
                                            wantedJobLocationKeywords.push(...["DE - 73116 Wäschenbeuren"]);
                                        }else if(key == "de-ha") {
                                            wantedJobLocationKeywords.push(...["DE - 30916 Isernhagen, Altwarmbüchen"]);
                                        }else if(key == "de-du") {
                                            wantedJobLocationKeywords.push(...["DE - Düsseldorf und Umgebung"]);
                                        }else if(key == "ch") {
                                            wantedJobLocationKeywords.push(...["CH - 8266 Steckborn"]);
                                        }else if(key == "ch-st") {
                                            wantedJobLocationKeywords.push(...["CH - 8266 Steckborn"]);
                                        }else if(key == "ch-be") {
                                            wantedJobLocationKeywords.push(...["CH - 8266 Steckborn"]);
                                        }else if(key == "it") {
                                            //wantedJobLocationKeywords.push(...["IT - 39044 Neumarkt", "IT - Milan"]);
                                        }else if(key == "it-ne") {
                                            wantedJobLocationKeywords.push(...["IT - 39044 Neumarkt"]);
                                        }else if(key == "it-mi") {
                                            wantedJobLocationKeywords.push(...["IT - Milan"]);
                                        }else if(key == "it-su") {
                                            wantedJobLocationKeywords.push(...["IT - Südtirol"]);
                                        }else if(key == "es") {
                                            wantedJobLocationKeywords.push(...["ES - 08271 Artés", "ES - 28046 Madrid"]);
                                        }else if(key == "es-ar") {
                                            wantedJobLocationKeywords.push(...["ES - 08271 Artés"]);
                                        }else if(key == "es-ma") {
                                            wantedJobLocationKeywords.push(...["ES - 28046 Madrid"]);
                                        }else if(key == "fr") {
                                            //wantedJobLocationKeywords.push(...["FR - 69150 Décines-Charpieu"]);
                                        }else if(key == "cz") {
                                            //wantedJobLocationKeywords.push(...["CZ - 370 11 České Budějovice"]);
                                        }else if(key == "sk") {
                                            wantedJobLocationKeywords.push(...["SK - 07 Vajnory"]);
                                        }else if(key == "pl") {
                                            wantedJobLocationKeywords.push(...["PL - 41-902 Bytom", "PL - 02-674 Warszawa", "PL - Warszawa"]);
                                        }else if(key == "be") {
                                            wantedJobLocationKeywords.push(...["BEL - 2560 Nijlen"]);
                                        }else if(key == "uk") {
                                            wantedJobLocationKeywords.push(...["UK - Theale RG7 4RA"]);
                                        }else if(key == "nl") {
                                            wantedJobLocationKeywords.push(...["NL - Amsterdam"]);
                                        }else if(key == "cn") {
                                            wantedJobLocationKeywords.push(...["CN - Shanghai"]);
                                        }else if(key == "us") {
                                            wantedJobLocationKeywords.push(...["US - PA 19060"]);
                                        }
                                    }
                                }
                            }
                        }
                        if(wantedJobLocationKeywords.length > 0) {
                            if(!wantedJobLocationKeywords.includes(job.location)) {
                                filterPassed = false;
                            }else{
                                filterPassed = true;
                            }
                        }


                        if(filterPassed == true) {
                            var title = "";
                            var description = "";
                            var searchString = "";
                            if(job.title) {
                                title = job.title.toLowerCase();
                            }
                            if(job.description) {
                                description = job.description.toLowerCase();
                            }
                            if(this.searchString) {
                                searchString = this.searchString.toLowerCase();
                            }

                            if(!title.includes(searchString) && !description.includes(searchString)){
                                filterPassed = false;
                            }
                        }


                    }
                }

                if (filterPassed === true) {
                    this.jobs.push(job);
                }
            });
        },
        toggleMobileFilter() {
            this.filterVisible = !this.filterVisible;
        },
        toggleCategoryVisible() {
            this.mobileLocationVisible = false;
            this.mobileTypeVisible = false;
            this.mobileCategoryVisible = !this.mobileCategoryVisible;
        },
        toggleLocationVisible() {
            this.mobileTypeVisible = false;
            this.mobileCategoryVisible = false;
            this.mobileLocationVisible = !this.mobileLocationVisible;
        },
        toggleTypeVisible() {
            this.mobileCategoryVisible = false;
            this.mobileLocationVisible = false;
            this.mobileTypeVisible = !this.mobileTypeVisible;
        }
    },
    created() {
        axios({
			method: 'post',
            withCredentials: true,
			url: 'https://jobs.loxone.com/wp-content/loxone/jobs/api_handler.php',
		}).then(response => {
            this.jobs = [];
            this.default_jobs = [];
            this.initiativ_jobs = [];

            for (let index in response.data) {
                    this.jobs.push(response.data[index]);
                    this.default_jobs.push(response.data[index]);
                if(response.data[index].zoho_id == '7166000000352163' && window.location.href.split('/')[3] == 'de'){
                    this.initiativ_jobs.push(response.data[index]);
                }else if(response.data[index].zoho_id == '7166000011051472' && window.location.href.split('/')[3] == 'en') {
                    this.initiativ_jobs.push(response.data[index]);
                }
            }
            console.log(this.jobs);


            let urlParams = new URLSearchParams(window.location.search);
            let url_location = urlParams.get('l'); // get the selected location via url

            if(url_location && this.job_locations[url_location]){
                this.job_locations[url_location].selected = true;
                if(this.job_locations[url_location]['entries']){ // if there are sublocations - select them per default too
                    for (const [filter_key] of Object.entries(this.job_locations[url_location]['entries'])) {
                        Object.entries(this.job_locations[url_location]['entries'][filter_key].selected = true);
                    }
                }
            }


            /* CHECK which Locations should be visible */
            for(const [filter_key, filter_value] of Object.entries(this.default_jobs)) {
                if(!filter_key) {
                    console.log('key not available');
                }
                switch(filter_value.location) {
                    //AT HANDLING
                    case 'AT - 4154 Kollerschlag':
                        this.job_locations.at.visible = true;
                        this.job_locations.at.entries['at-ko'].visible = true;
                        break;
                    case 'AT - 4211 Alberndorf':
                        this.job_locations.at.visible = true;
                        this.job_locations.at.entries['at-al'].visible = true;
                        break;
                    case 'AT - 1010 Wien':
                        this.job_locations.at.visible = true;
                        this.job_locations.at.entries['at-wi'].visible = true;
                        break;
                    //DE HANDLING
                    case 'DE - 30916 Isernhagen, Altwarmbüchen':
                        this.job_locations.de.visible = true;
                        this.job_locations.de.entries['de-ha'].visible = true;
                        break;
                    case 'DE - 73116 Wäschenbeuren':
                        this.job_locations.de.visible = true;
                        this.job_locations.de.entries['de-wa'].visible = true;
                        break;
                    case 'DE - Düsseldorf und Umgebung':
                        this.job_locations.de.visible = true;
                        this.job_locations.de.entries['de-du'].visible = true;
                        break;
                    //CH HANDLING
                    case 'CH - 8266 Steckborn':
                        this.job_locations.ch.visible = true;
                        this.job_locations.ch.entries['ch-st'].visible = true;
                        break;
                    case 'CH - MISSING':
                        this.job_locations.ch.visible = true;
                        this.job_locations.ch.entries['ch-be'].visible = true;
                        break;
                    //IT HANDLING
                    case 'IT - 39044 Neumarkt':
                        this.job_locations.it.visible = true;
                        this.job_locations.it.entries['it-ne'].visible = true;
                        break;
                    case 'IT - Milan':
                        this.job_locations.it.visible = true;
                        this.job_locations.it.entries['it-mi'].visible = true;
                        break;
                    case 'IT - Südtirol':
                        this.job_locations.it.visible = true;
                        this.job_locations.it.entries['it-su'].visible = true;
                        break;
                    //ES HANDLING
                    case 'ES - 08271 Artés':
                        this.job_locations.es.visible = true;
                        this.job_locations.es.entries['es-ar'].visible = true;
                        break;
                    case 'ES - MISSING':
                    case 'ES - 28046 Madrid':
                        this.job_locations.es.visible = true;
                        this.job_locations.es.entries['es-ma'].visible = true;
                        break;
                    //FR HANDLING
                    case 'FR - 69740 Genas':
                        this.job_locations.fr.visible = true;
                        break;
                    //CZ HANDLING
                    case 'CZ - Prague':
                    case 'CZ - 370 11 České Budějovice':
                        this.job_locations.cz.visible = true;
                        break;
                    //SK HANDLING
                    case 'SK - 07 Vajnory':
                        this.job_locations.sk.visible = true;
                        break;
                    //PL HANDLING
                    case 'PL - Warszawa':
                    case 'PL - 02-674 Warszawa':
                    case 'PL - 41-902 Bytom':
                        this.job_locations.pl.visible = true;
                        break;
                    //BE HANDLING
                    case 'BEL - 2560 Nijlen':
                        this.job_locations.be.visible = true;
                        break;
                    //UK HANDLING
                    case 'UK - Reading, Theale, RG7 4RA':
                    case 'UK - Theale RG7 4RA':
                    case 'Reading, Theale, RG7 4RA':
                        this.job_locations.uk.visible = true;
                        break;
                    //CN HANDLING
                    case 'CN - Shanghai':
                        this.job_locations.cn.visible = true;
                        break;
                    //US HANDLING
                    case 'US - PA 19060':
                        this.job_locations.us.visible = true;
                        break;
                }
            }
            
            if(document.referrer.includes('/detail/') || (window.performance && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD)) {
                var types = localStorage.getItem('selected_types').split(',');
                var categories = localStorage.getItem('selected_categories').split(',');
                var locations = localStorage.getItem('selected_locations').split(',');

                for (const [filter_key, filter_value] of Object.entries(this.job_types)) {
                    types.forEach(e => {
                        if(e === filter_key) {
                            filter_value.selected = true;
                        }
                    });
                }

                for (const [filter_key, filter_value] of Object.entries(this.job_categories)) {
                    categories.forEach(e => {
                        if(e === filter_key) {
                            filter_value.selected = true;
                        }
                    });
                }

                for (const [filter_key, filter_value] of Object.entries(this.job_locations)) {
                    locations.forEach(e => {
                        if(e === filter_key) {
                            filter_value.selected = true;
                        }
                    });

                    if(filter_value.entries && filter_key){
                        for(const [key, value] of Object.entries(filter_value.entries)) {
                            locations.forEach(e => {
                                if(e === key) {
                                    value.selected = true;
                                }
                            });
                        }
                    }
                }
            }
            localStorage.setItem('selected_categories', null);
            localStorage.setItem('selected_locations', null);
            localStorage.setItem('selected_types', null);

            this.updateJobList();
        });
    },
    mounted() {
    },
    watch: {
        job_types: {
            handler() {
                this.updateJobList();
            },
            deep: true
        },
        job_categories: {
            handler() {
                this.updateJobList();
            },
            deep: true
        },
        job_locations: {
            handler() {
                this.updateJobList();
            },
            deep: true
        },
        currentPage() {
            if(this.currentPage < 1) {
                this.currentPage = 1;
            }

            if(this.currentPage > Math.ceil(this.jobs.length / this.perPage)) {
                this.currentPage = Math.ceil(this.jobs.length / this.perPage);
            }
        },
        searchString() {
            this.updateJobList();
        }
    }
}
</script>

<style>

    #app{
        display: grid;
        grid-template-areas: "search search" "sidebar main";
        font-family: Arial, Helvetica, sans-serif;
        grid-template-columns: 300px auto;
    }
    #job_sidebar{
        grid-area: sidebar;
        width: 300px;
        padding-right: 30px;
        box-sizing: border-box;
    }
    #job_sidebar .filter__header{
        display: flex;
        justify-content: space-between;
    }
    #job_sidebar button{
        color: #E73246;
        appearance: none;
        display: inline-block;
        border: none;
        outline: none;
        background: transparent;
        padding: 0;
        font-size: 16px;
        margin-bottom: 20px;
        padding-bottom: 0;
        cursor: pointer;
    }
    #job_sidebar hr{
        display: block;
        height: 1px;
        background-color: #979797;
        appearance: none;
        outline: none;
        border: none;
        margin: 15px 0;
    }
    h2{
        margin: 0;
        font-size: 23px;
        padding-bottom: 20px !important;
        font-family: 'averta-extrabold',Arial,sans-serif;
    }
    #job_sidebar h3{
        margin: 0;
        font-size: 16px;
        padding-bottom: 20px !important;
        font-family: 'averta-extrabold',Arial,sans-serif;
    }

    .filter{
        margin-bottom: 15px;
        font-size: 16px;
        line-height: 20px;
        color: #575C61;
        cursor: pointer;
    }
    .filter--sub{
        margin-top: 10px;
        padding-left: 25px;
    }
    .filter:last-child{
        padding-bottom: 40px;
    }

    .filter label{
        display: inline-block;
        cursor: pointer;
    }

    .filter input,
    .filter .fake--input{
        width: 16px;
        height: 16px;
        appearance: none;
        border: 1px solid #979797;
        outline: none;
        vertical-align: top;
        margin: 0 7px 0 0;
    }

    .filter .fake--input{
        background-color: #E73246;
        border-color: #E73246;
        display: inline-block;
        box-sizing: border-box;
    }

    .filter .fake--input svg{
        margin: 2px;
    }

    #job_content{
        border-left: 1px solid #979797;
        padding: 0 20px;
        grid-area: main;
    }
    #job_search{
        grid-area: search;
        padding: 0 45px 45px 45px;
        position: relative;
    }

    #job_search input{
        font-size: 16px;
        color: #575C61;
        line-height: 58px;
        height: 58px;
        border: 1px solid #9D9D9D;
        outline: none;
        border-radius: 0;
        padding-left: 55px;
        padding-right: 20px;
        width: 100%;
    }

    .job__entry{
        padding-bottom: 40px;
    }

    .job__entry .job__entry--title{
        font-family: 'averta-extrabold',Arial,sans-serif;
        font-size: 23px;
        line-height: 30px;
        margin-bottom: 5px;
        padding: 0 !important;
        color: #000A12;
    }

    .job__entry .job__entry--meta{
        font-size: 16px;
        color: #000A12;
        margin-bottom: 10px;
    }

    .job__entry .job__entry--description{
        font-size: 16px;
        color: #575C61;
    }

    .job__pagination{
        text-align: right;
    }

    .pagination__entry{
        display: inline-block;
        width: 40px;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        box-sizing: border-box;
        cursor: pointer;
        vertical-align: top;
        -webkit-user-select: none; /* Safari */
        -ms-user-select: none; /* IE 10 and IE 11 */
        user-select: none; /* Standard syntax */
        text-align: center;
    }
    .pagination__entry.active{
        font-weight: bold;
    }
    .pagination__entry.first .arrow{
        transform: rotate(-135deg);
        margin-top: 11px;
    }
    .pagination__entry.last .arrow{
        transform: rotate(45deg);
        margin-top: 11px;
        margin-left: -11px;
    }

    .pagination__entry .arrow{
        width: 15px;
        height: 15px;
        display: inline-block;
        border-top: 1px solid black;
        border-right: 1px solid black;
    }
    @media screen and (max-width: 900px) {
        label{
            white-space: nowrap;
        }
        .filter__category.visible .filter__wrapper{
            display: block !important;
        }

        .filter__wrapper{
            display: none;
        }
        .filter{
            display: block;
        }

        .filter input,
        .filter .fake--input{
            display: none !important;
        }

        .filter{
            padding: 5px 10px;
            border-radius: 4px;
            overflow: hidden;
        }

        #app{
            grid-template-areas: "search search" "sidebar sidebar" "main main";
        }

        .job__entry--description{
            display: none;
        }

        #job_content{
            border-left: none;
            padding-left: 0;
            padding-right: 0;
            padding-top: 20px;

        }
        #job_sidebar{
            padding: 0;
            width: 100%;
        }


        .job__pagination {
            text-align: center;
        }


        .category__headline{
            cursor: pointer;
            padding-top: 20px;
            padding-bottom: 12px !important;
            position: relative;
            display: inline-block;
            padding-right: 25px;
        }

        .category__headline:before,
        .category__headline:after{
            display: inline-block !important;
            width: 2px;
            height: 10px;
            background-color: #000;
            transform: rotate(-45deg);
            position: absolute;
            content: "";
            right: 9px;
            top: 25px;
        }

        .category__headline:after{
            transform: rotate(45deg);
            right: 3px;
        }

        .filter__category.visible .category__headline:after{
            transform: rotate(-45deg);
            right: 3pxpx;
        }
        .filter__category.visible .category__headline:before{
            transform: rotate(45deg);
            right: 10px;
        }

        .filter__category--wrapper{
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid black;
        }

        .filter__category{
            display: inline-block;
            vertical-align: top;
            margin-right: 20px;
            position: relative;
            font-size: 14px;
        }

        .filter__wrapper{
            position: absolute;
            top: 50px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
            padding: 10px;
            left: 0;
            background-color: #FFFFFF;
            z-index: 9999;

        }

        .filter__category > .filter,
        .filter__category > .filter__wrapper > .filter{
            margin-top: 10px;
            padding-left: 10px;
            display: block;
            padding: 5px 10px !important;
            border: 1px solid lightgray;
            border-radius: 20px;
            margin: 0 10px 10px 0;
        }

        .filter--hidden{
            display: none !important;
        }

        .filter--sub{
            display: none;
        }

        .filter.active{
            color: #FFFFFF;
            border-color: #69c350;
            background-color: #69c350;
        }

        .filter__header h3{
            position: relative;
            padding-right: 26px;
        }
        
        .filter__header{
            border-bottom: 1px solid #000000;
        }

        .filter__header.active{
            border-bottom: 0;
        }

        hr{
            display: none !important;
        }

        #job_sidebar.js-sticky{
            position: fixed;
            top: 48px;
            left: 0;
            right: 0;
            z-index: 999999;
            background: white;
            padding: 0 10px;

        }
        
        #job_sidebar.js-sticky .filter__header{
            display: none !important;
        }

        #job_sidebar.hidden .filter__header .link{
            display: none;
        }

        #job_sidebar.hidden .filter__category{
            display: none;
        }
        #job_sidebar h3.category__headline{
            font-size: 12px !important;
        }
        .et_pb_section.et_pb_section_3.et_section_regular{
            z-index: 9;
        }
    }
</style>
